console.log('checkoooo');

(function($) {
  function render_map( $el ) {
    var $markers = $el.find('.marker');
    var args = {
      zoom		: 15,
      center		: new window.google.maps.LatLng(0, 0),
      mapTypeId	: window.google.maps.MapTypeId.ROADMAP,
    };
    var map = new window.google.maps.Map( $el[0], args);
    map.markers = [];
    $markers.each(function(){
      add_marker( $(this), map );
    });

    // center map
    center_map( map );
  }

  function add_marker( $marker, map ) {
    var latlng = new window.google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    var marker = new window.google.maps.Marker({
      position	: latlng,
      map			: map,
    });

    map.markers.push( marker );
    if( $marker.html() ) {
      var infowindow = new window.google.maps.InfoWindow({
    /*  var infowindow = new google.maps.InfoWindow({*/
        content		: $marker.html(),
      });

      window.google.maps.event.addListener(marker, 'click', function() {
        infowindow.open( map, marker );
      });
    }
  }

  function center_map( map ) {
    var bounds = new window.google.maps.LatLngBounds();
    $.each( map.markers, function( i, marker ){
      var latlng = new window.google.maps.LatLng( marker.position.lat(), marker.position.lng() );
      bounds.extend( latlng );
    });

    if( map.markers.length == 1 ) {
      map.setCenter( bounds.getCenter() );
      map.setZoom( 15 );
    } else {
      map.fitBounds( bounds );
    }
  }

  $(document).ready(function(){
    $('.acf-map').each(function(){
      render_map( $(this) );
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/maps.js